module.exports = __webpack_public_path__ + "static/img/cont49 (6).ad23d70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (6).jpg
// module id = UrGq
// module chunks = 0